import { render, staticRenderFns } from "./ProductSalesReportDetail.vue?vue&type=template&id=a396a422&"
import script from "./ProductSalesReportDetail.vue?vue&type=script&lang=js&"
export * from "./ProductSalesReportDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports